import React, { useState } from 'react';

interface ToggleProps {
  title?: React.ReactNode;
  count?: number;
  children?: React.ReactNode;
}

export function Toggle({ title, count, children }: ToggleProps) {
  const [hidden, setHidden] = useState(false);

  return (
    <section className="fase-monitor__card fase-monitor__section">
      <button
        type="button"
        className="fase-monitor__section-header"
        aria-expanded={!hidden}
        onClick={() => setHidden(!hidden)}
      >
        <div className="fase-monitor__section-header-left">
          <span className="fase-monitor__section-title">{title}</span>
          {typeof count === 'number' && <span className="fase-monitor__section-badge">{count}</span>}
        </div>
        <span className={`fase-monitor__chevron ${hidden ? 'fase-monitor__chevron--collapsed' : ''}`} />
      </button>
      {!hidden && <div className="fase-monitor__section-body">{children}</div>}
    </section>
  );
}
